import {
    IAccount,
    IAccountMappingSubFLI,
    IAccountMappingTemplateGroup,
    IAccountMappingTemplateGroupItemFLI,
    IAccountMappingTemplateGroupItemSubtotal,
    IReclassesAccounts,
} from '@modeso/types__aumico-lib-annualreport-be';

export type CalculableMappingItems =
    | IAccountMappingTemplateGroup
    | IReclassesAccounts
    | IAccount
    | IAccountMappingTemplateGroupItemFLI
    | IAccountMappingSubFLI
    | IAccountMappingTemplateGroupItemSubtotal;
